import { render, staticRenderFns } from "./GridPaging.vue?vue&type=template&id=056e2604"
import script from "./GridPaging.vue?vue&type=script&lang=js"
export * from "./GridPaging.vue?vue&type=script&lang=js"
import style0 from "./GridPaging.vue?vue&type=style&index=0&id=056e2604&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports